import { ApplicationEnvironment } from '../catalog/application.environment';

export enum DeviceType {
  Phone = 'Phone',
  Tablet = 'Tablet',
  Desktop = 'Desktop',
  Other = 'Other'
}

export interface UserDeviceInfo {
  _id?: string;
  hash?: string;
  browser?: string;
  browserVersion?: string;
  os?: string;
  deviceType: DeviceType;
  device?: string;
  userAgent?: string;
  osVersion?: string;
  ipAddress?: string;
  lat?: number;
  lgn?: number;
  location?: string;
  isMobileApp?: boolean;
  isDistrbution?: boolean;
  isLogin?: boolean;
  environment?: ApplicationEnvironment;
  appVersion?: string;
  supportMfa?: boolean;
}
